import {
    CLEAR_OPPORTUNITY, CLEAR_SEARCH_OPPORTUNITIES, EMPTY_OPPORTUNITIES,
    FETCH_OPPORTUNITIES, FETCH_OPPORTUNITIES_SUCCESS, FETCH_OPPORTUNITIES_FAILURE,
    FETCH_OPPORTUNITY, FETCH_OPPORTUNITY_SUCCESS, FETCH_OPPORTUNITY_FAILURE,
    REMOVE_OPPORTUNITY, REMOVE_OPPORTUNITY_SUCCESS, REMOVE_OPPORTUNITY_FAILURE,
    SAVE_OPPORTUNITY, SAVE_OPPORTUNITY_SUCCESS, SAVE_OPPORTUNITY_FAILURE,
    SET_OPPORTUNITY, SET_OPPORTUNITIES_FILTERS, SET_OPPORTUNITY_EMPTY_STATE, SET_OPPORTUNITIES_SEARCH_FIELD,
    UPDATE_OPPORTUNITIES, SEARCH_OPPORTUNITIES, SEARCH_OPPORTUNITIES_SUCCESS,
    SEARCH_OPPORTUNITIES_FAILURE
} from './constants';

import Request from 'utils/request';
import { PATHS } from 'utils/paths';

export const clearOpportunity = () => ({
    type: CLEAR_OPPORTUNITY
});

export const clearSearchOpportunities = () => ({
    type: CLEAR_SEARCH_OPPORTUNITIES
});

export const emptyOpportunities = () => ({
    type: EMPTY_OPPORTUNITIES
});

const fetchOpportunities = (hideSpinner) => ({
    type: FETCH_OPPORTUNITIES,
    hideSpinner
});

const fetchOpportunitiesSuccess = (data) => ({
    type: FETCH_OPPORTUNITIES_SUCCESS,
    data
});

const fetchOpportunitiesFailure = (error) => ({
    type: FETCH_OPPORTUNITIES_FAILURE,
    error
});

const fetchOpportunity = () => ({
    type: FETCH_OPPORTUNITY
});

const fetchOpportunitySuccess = (data) => ({
    type: FETCH_OPPORTUNITY_SUCCESS,
    data
});

const fetchOpportunityFailure = (error) => ({
    type: FETCH_OPPORTUNITY_FAILURE,
    error
});

const removeOpportunity = () => ({
    type: REMOVE_OPPORTUNITY
});

const removeOpportunitySuccess = () => ({
    type: REMOVE_OPPORTUNITY_SUCCESS
});

const removeOpportunityFailure = (error) => ({
    type: REMOVE_OPPORTUNITY_FAILURE,
    error
});

const saveOpportunity = () => ({
    type: SAVE_OPPORTUNITY
});

const saveOpportunitySuccess = (data) => ({
    type: SAVE_OPPORTUNITY_SUCCESS,
    data
});

const saveOpportunityFailure = (error) => ({
    type: SAVE_OPPORTUNITY_FAILURE,
    error
});

export const setOpportunity = (data) => ({
    type: SET_OPPORTUNITY,
    data
});

export const setOpportunityEmptyState = (data) => ({
    type: SET_OPPORTUNITY_EMPTY_STATE,
    data
});

export const searchOpportunities = () => ({
    type: SEARCH_OPPORTUNITIES
});

export const searchOpportunitiesSuccess = (data) => ({
    type: SEARCH_OPPORTUNITIES_SUCCESS,
    data
});

export const searchOpportunitiesFailure = (error) => ({
    type: SEARCH_OPPORTUNITIES_FAILURE,
    error
});

export const setOpportunitiesFilters = (data) => ({
    type: SET_OPPORTUNITIES_FILTERS,
    data
});

export const setOpportunitiesSearchField = (data) => ({
    type: SET_OPPORTUNITIES_SEARCH_FIELD,
    data
});

export const updateOpportunities = (data) => ({
    type: UPDATE_OPPORTUNITIES,
    data
});



/**
 *  ASYNC ACTIONS
 */
export const deleteOpportunity = () => (dispatch, getStore) => {
    dispatch(removeOpportunity());

    let opportunity = getStore().opportunities.opportunity;

    let request = new Request(getStore().auth.token);

    return request.post(PATHS.opportunity.delete(opportunity.id))
        .then((response) => {
            dispatch(removeOpportunitySuccess());
            return response;
        })
        .catch((error) => {
            console.log('deleteOpportunity error', error, error.response);
            error.friendlyMessage = 'There was an error deleting your posting. Please try again.';
            dispatch(removeOpportunityFailure(error));
            throw error;
        });
};

export const getOpportunitiesForCompany = (companyId, hideSpinner) => (dispatch, getStore) => {
    dispatch(fetchOpportunities(hideSpinner));

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.opportunity.getForCompany(companyId))
        .then((response) => {
            let opportunities = {
                published: [],
                drafts: []
            };
            response.data.data.forEach((opportunity) => {
                if(opportunity.published === true) {
                    opportunities.published.push(opportunity);
                } else {
                    opportunities.drafts.push(opportunity);
                }
            });
            dispatch(fetchOpportunitiesSuccess(opportunities));
            return response;
        })
        .catch((error) => {
            console.log('getOpportunitiesForCompany error', error, error.response);
            error.friendlyMessage = 'There was an error getting your company postings. Please try again.';
            dispatch(fetchOpportunitiesFailure(error));
            throw error;
        });
};

export const getOpportunityById = (opportunityId) => (dispatch, getStore) => {
    dispatch(fetchOpportunity());

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.opportunity.getById(opportunityId))
        .then((response) => {
            dispatch(fetchOpportunitySuccess(response.data.data));
            return response;
        })
        .catch((error) => {
            console.log('getOpportunityById error', error, error.response);
            error.friendlyMessage = 'There was an error getting this opportunity. Please try again.';
            dispatch(fetchOpportunityFailure(error));
            throw error;
        });
};

export const getSearchForOpportunities = () => (dispatch, getStore) => {
    dispatch(searchOpportunities());

    let searchTerm = getStore().opportunities.searchTerm;
    let filters = getStore().opportunities.filters;

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.opportunity.search(searchTerm, filters.specializationIds.join(','), filters.experienceIds.join(',')))
        .then((response) => {
            let results = response.data.data;
            dispatch(searchOpportunitiesSuccess(results));
            return response;
        })
        .catch((error) => {
            console.log('getSearchForOpportunities error', error, error.response);
            error.friendlyMessage = 'There was an issue performing this search.  Please try again.';
            dispatch(searchOpportunitiesFailure(error));
            throw error;
        });
};

export const postPutOpportunity = () => (dispatch, getStore) => {
    dispatch(saveOpportunity());

    let opportunity = getStore().opportunities.opportunity;

    let request = new Request(getStore().auth.token);

    let requestFunc = request.post;
    let url = PATHS.opportunity.create();

    if(opportunity.id != null) {
        requestFunc = request.put;
        url = PATHS.opportunity.save(opportunity.id);
    }

    if(opportunity.companyId == null) {
        opportunity.companyId = getStore().auth.user.company.id;
    }

    return requestFunc(url, opportunity)
        .then((response) => {
            dispatch(saveOpportunitySuccess(response.data.data));
            return response;
        })
        .catch((error) => {
            console.log('postPutOpportunity error', error, error.response);
            error.friendlyMessage = 'There was an error saving this job posting. Please try again.';
            dispatch(saveOpportunityFailure(error));
            throw error;
        });
};



// WEBPACK FOOTER //
// ./src/containers/Opportunities/store/actions.js